import { ProjectComponent } from "../components/Project/projectComponent";

export const ProjectPublic = () => {
    return (
        <ProjectComponent isPublic="1"></ProjectComponent>
    );
};